import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {environment} from '../../../../../free/src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PlansDataService {
    orderIdKey = 'orderId';
    apiUrl = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private auth: AuthService,
    ) {
    }

    generateUniqId() {
        const date = new Date().getTime();
        const s = Math.floor(date / 1000).toString(16).toUpperCase();
        const partOne = s.slice(0, s.length / 2).trim();
        const partTwo = s.slice(s.length / 2, s.length).trim();
        return `${partTwo}${partOne}`;
    }

    getPlans(apiUrl: string, id: any): Observable<any> {
        return this.http.get(`${apiUrl}/storage/planset/${id}`);
    }

    set orderId(prop: string | null) {
        prop ? localStorage.setItem(this.orderIdKey, prop) : localStorage.removeItem(this.orderIdKey);
    }

    generateLiqPayLink(uid: string, orderId: string, pid: string, type: 'authorize' | 'capture', url: string, returnUrl: string) {
        return `${url}/orders?uid=${uid}&orderid=${orderId}&package=${pid}&type=${type}&redirectUrl=${window.location.host}/${returnUrl}`;
    }

    pay(apiUrl, prop: any, subscription: boolean) {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`
        });
        const url = subscription ? `${apiUrl}/subscription` : `${apiUrl}/order`;
        const body = {
            plan_id: prop.id,
            discount_id: prop?.discount_id || null,
            referrer_id: prop?.referrer_id || null,
            result_url: window.location.origin + '/ap'
        };
        return this.http.post(url, body, {
            headers,
        });
    }

    applyPromo(data: {
        plan_id: string,
        discount_id: string
    }) {
        return this.http.post(`${this.apiUrl}/discount`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
                },
                responseType: 'text'
            });
    }
}
